import React from "react";
import PropTypes from "prop-types";

import { Select } from "antd";

const propTypes = {
  handlerChange: PropTypes.func,
  height: PropTypes.number,
  isClearable: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)),
  loadOptions: PropTypes.func,
  returnAll: PropTypes.bool,
  simple: PropTypes.bool,
  value: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.string,
  ]),
};

const defaultProps = {
  handlerChange: undefined,
  height: 40,
  isClearable: true,
  options: [],
  returnAll: false,
  loadOptions: undefined,
  simple: true,
  value: null,
};

function SelectInput({
  value,
  loadOptions,
  onChange,
  options,
  returnAll,
  simple,
  ...rest
}) {
  const Options = options.map((option) => (
    <Select.Option key={option.value} value={option.value}>
      {option.label}
    </Select.Option>
  ));

  return (
    <Select onChange={(val) => onChange(val)} value={value || []} {...rest}>
      {Options}
    </Select>
  );
}

SelectInput.propTypes = propTypes;
SelectInput.defaultProps = defaultProps;

export default SelectInput;
